// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCBegSC-C9Sld167YqKd3B-f2R5qmR5-UE",
  authDomain: "thingiverse-explore.firebaseapp.com",
  projectId: "thingiverse-explore",
  storageBucket: "thingiverse-explore.appspot.com",
  messagingSenderId: "1085956509686",
  appId: "1:1085956509686:web:a055e2710de54e339c41d7",
  measurementId: "G-0PDCPWPRE5",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
export const functions = getFunctions(app);
export const auth = getAuth(app);
export const db = getFirestore(app);
export default app;
